import React, { useState, useEffect } from 'react'
// import './ForeFlight.css'
import PortalHeader from '../../../client-dashboard/clientNavbar/PortalHeader';
import { Link } from 'react-router-dom';
import Flipbook from '../../client-dashboard-manual/Flipbook';
import { useAuth } from '../../../Auth';
import orgsJson from './orgs_json.json';

// Assets
import foreFlightBanner from '../../client-dashboard-assets/product-suit-assets/apiendpoint-banner.jpg'
import foreFlightPdf from '../../client-dashboard-assets/product-suit-assets/apiendpoint-pdf.pdf';

// Interface for getting the available org content
interface ApiEdpointInfo {
    apiID: number;
    Attributes: string[];
    AreaCoverage: string;
    Delivery: string;
}

const ApiEndpoint = () => {
    // Ensure the page always start at the top
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top when the component mounts
    }, []);

    const [searchTerm, setSearchTerm] = useState('');
    const [sortAsc, setSortAsc] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const { first_name, last_name, email, organization, ps_id } = useAuth();
    const [apiInfo, setApiInfo] = useState<ApiEdpointInfo[]>([]);

    // useEffect(() => {
    //     const fetchApiInfo = async () => {
    //         try {
    //             const response = await fetch('/orgs_json.json', {
    //                 credentials: 'same-origin' // ensures cookies/session are sent for auth
    //             });

    //             const data = await response.json();
    //             // console.log(data)

    //             if (response.ok) {
    //                 setApiInfo(data); // Assign the fetched gallery data to state
    //             } else {
    //                 console.error("Failed to load api information:", data.error || response.statusText);
    //             }
    //         } catch (error) {
    //             console.error("❌ Error fetching api information:", error);
    //         }
    //     };

    //     fetchApiInfo();
    // }, []);

    useEffect(() => {
        setApiInfo(orgsJson);
    }, []);

    const matchedApi = apiInfo.find(api => Number(api.apiID) === Number(ps_id));

    const attributeDescriptions: { [key: string]: string } = {
        Date: "Timestamp of the detected strike",
        Coordinates: "Latitude and longitude of the strike",
        HRLRating: "A risk score from 0 to 100 indicating the potential danger of a lightning strike",
        Precipitation: "Total rainfall recorded at the strike location.",
        ERC: "Indicates potential fire intensity based on available fuels",
        Humidity: "Indicates atmospheric moisture content at the strike location",
        KBDI: "Indicates soil dryness and fire potential"
    };


    // console.log(apiInfo)

    return (
        <div className="overall-div-for-suite">

            <PortalHeader />

            <div className="suite-hero-section">
                <img src={foreFlightBanner} alt='foreflight-banner'></img>
                <div className="dark-overlay"></div>

                <div className="suite-wrapper">
                    <h1>API Endpoint</h1>
                </div>
            </div>

            <div className='suite-default-info'>

                <div className='suite-info1'>
                    <h1><strong>API Documentation</strong></h1>

                    <p>Everything you need to start integrating High-Risk-Lightning™ (HRL™) data.</p>

                    <div className='manual-flipbook'>
                        <Flipbook
                            pdfUrl={foreFlightPdf}
                            forcedHeight={{
                                large: 800,
                                medium: 670,
                                small: 540
                            }}
                        />


                    </div>
                </div>



                <div className='suite-info1'>
                    <h2><strong>Organization</strong></h2>
                    <p style={{ color: '#28aae1' }}>{organization}</p>
                </div>

                <div className='suite-info1'>
                    <h2><strong>API Key</strong></h2>
                    <p>Click the button below to request your unique API key. </p>
                    <button
                        onClick={async () => {
                            // Trigger the email request
                            const res = await fetch('/portal/api/send-brevo-email/', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    firstName: first_name,
                                    lastName: last_name,
                                    email: email,
                                    isEmail2: true,
                                }),
                            });

                            // Handle response
                            if (res.ok) {
                                setShowPopup(true); // Only show popup if email was successfully sent
                            } else {
                                const data = await res.json();
                                console.error('Failed to send email:', data);
                                alert('There was a problem sending your request.');
                            }
                        }}
                    >
                        Request Key
                    </button>

                </div>


                <div className='suite-info1'>
                    <h2><strong>API End Point Link</strong></h2>
                    <p>Base URL for accessing your HRL™ data.</p>
                    <a
                        href="https://fireneuralnetwork.com/map/fnn_lightning"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none', color: '#28aae1' }}
                    >
                        <strong> https://fireneuralnetwork.com/map/fnn_lightning </strong>
                    </a>
                </div>

                <div className='suite-info1'>
                    <h2><strong>Data Information </strong></h2>
                    <p>The FNN™ API provides access to key HRL™ strike attributes designed for seamless integration into your systems.</p>

                    {matchedApi && (
                        <div className='suite-info1-inner'>
                            {Object.entries(attributeDescriptions).map(([key, description]) => {
                                if (matchedApi.Attributes.includes(key)) {
                                    return (
                                        <React.Fragment key={key}>
                                            <p style={{ color: '#28aae1' }}>{key === "HRLRating" ? "HRL™ Rating" : key}</p>
                                            <p style={{ marginBottom: '1rem' }}>{description}</p>
                                        </React.Fragment>
                                    );
                                }
                                return null;
                            })}
                        </div>
                    )}

                    <p><strong>Note: Available properties may vary based on your service tier and geographic region.</strong></p>
                </div>


                {matchedApi?.AreaCoverage && (
                    <div className='suite-info1'>
                        <h2><strong>Area Coverage</strong></h2>
                        <p>Specifies the geographic region where HRL™ data is collected</p>
                        <p style={{ color: '#28aae1' }}>{matchedApi.AreaCoverage}</p>
                    </div>
                )}

                {matchedApi?.Delivery && (
                    <div className='suite-info1'>
                        <h2><strong>Data Delivery</strong></h2>
                        <p>The frequency at which data is sent</p>
                        <p style={{ color: '#28aae1' }}>{matchedApi.Delivery}</p>
                    </div>
                )}

            </div>

            <div className='suite-info1'>
                <h2><strong>Questions About Your HRL Delivery?</strong></h2>
                <p>Need to make changes to your recipient list?</p>
                <p>Need to adjust your delivery method or schedule?</p>
                <Link to='/fnn_portal_representative'><button>Contact Us</button></Link>

            </div>


            {showPopup && (
                <div className="suite-popup-overlay">
                    <div className="suite-popup-content">
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }} className='faq-adjust-buttons suite-extension'>
                            <button
                                style={{ paddingLeft: '1rem', paddingRight: '1rem' }}
                                onClick={() => setShowPopup(false)}
                            >
                                <strong>Back</strong>
                            </button>
                        </div>

                        <h1 className='api-h1'>API Key Request Sent</h1>
                        <p>Thank you for your request.</p>

                        <div className='api-popup-middle'>
                            <h2>An FNN™ representative will contact you shortly to verify your information and provide secure access to your unique API key.</h2>
                        </div>

                        <p>If you have any questions in the meantime, feel free to contact us.</p>

                        <Link to='/fnn_portal_representative'>
                            <button className='suite-popup-content-btn'>Contact Us</button>
                        </Link>
                    </div>
                </div>
            )}


        </div>


    )
}

export default ApiEndpoint